"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/SendLaterPanel.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _scheduledMessages = require('shared/services/scheduledMessages');
var _timeZones = require('shared/services/timeZones');
var _ScheduleTimeZone = require('web/components/ScheduleTimeZone'); var _ScheduleTimeZone2 = _interopRequireDefault(_ScheduleTimeZone);

// datetime-local holds a wall time, to the minute; it is read in the zone
// the times are in, not the browser's.
const SKIPPED_TIME = "That time doesn't happen that day: the clocks go forward an hour. Pick another time."
// The picker's earliest minute that is still a minute out.
const ceilToMinute = (date) => new Date(Math.ceil(date.getTime() / 60000) * 60000)








const PresetRow = _react.memo.call(void 0, ({ preset, disabled, onPick }) => {
  const onClick = _react.useCallback.call(void 0, () => onPick(preset.sendAt), [onPick, preset])
  return (
    _react2.default.createElement('button', { type: "button", className: "send-later--preset", disabled: disabled, onClick: onClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 25}}
      , _react2.default.createElement('span', { className: "send-later--preset-label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 26}}, preset.label)
      , _react2.default.createElement('span', { className: "send-later--preset-time", __self: this, __source: {fileName: _jsxFileName, lineNumber: 27}}, preset.detail)
    )
  )
})
PresetRow.displayName = 'SendLaterPresetRow'
















// Send later's popover above the composer: the presets, then a custom date
// and time between a minute and a year out, and the zone they are in (the
// browser's unless the user picked another). One send only: there is no repeat.
const SendLaterPanel = ({
  title, submitLabel = 'Schedule', now: givenNow, error, busy, timeZone, onTimeZoneChange, onPick, onClose,
}) => {
  const now = _react.useMemo.call(void 0, () => givenNow || new Date(), [givenNow])
  const presets = _react.useMemo.call(void 0, () => _scheduledMessages.sendLaterPresets.call(void 0, now, timeZone), [now, timeZone])
  const [custom, setCustom] = _react.useState.call(void 0, false)
  const [value, setValue] = _react.useState.call(void 0, '')
  const [skipped, setSkipped] = _react.useState.call(void 0, false)
  const titleId = _react.useId.call(void 0, )
  const inputId = _react.useId.call(void 0, )
  const panel = _react.useRef(null)

  _react.useLayoutEffect.call(void 0, () => {
    _optionalChain([panel, 'access', _ => _.current, 'optionalAccess', _2 => _2.querySelector, 'call', _3 => _3('button'), 'optionalAccess', _4 => _4.focus, 'call', _5 => _5()])
  }, [])

  const latest = _react.useRef.call(void 0, { onClose })
  _react.useLayoutEffect.call(void 0, () => {
    latest.current = { onClose }
  })
  _react.useEffect.call(void 0, () => {
    const onMouseDown = (event) => {
      // SAFETY: a mousedown on the document always targets a DOM node.
      if (_optionalChain([panel, 'access', _6 => _6.current, 'optionalAccess', _7 => _7.contains, 'call', _8 => _8(event.target )])) return
      latest.current.onClose()
    }
    document.addEventListener('mousedown', onMouseDown)
    return () => document.removeEventListener('mousedown', onMouseDown)
  }, [])

  const onKeyDown = _react.useCallback.call(void 0, (event) => {
    if (event.key !== 'Escape') return
    event.preventDefault()
    event.stopPropagation()
    onClose()
  }, [onClose])

  const showCustom = _react.useCallback.call(void 0, () => {
    setValue(current => current || _timeZones.toWallValue.call(void 0, ceilToMinute(_scheduledMessages.earliestSendAt.call(void 0, now)), timeZone))
    setCustom(true)
  }, [now, timeZone])

  _react.useLayoutEffect.call(void 0, () => {
    if (custom) _optionalChain([document, 'access', _9 => _9.getElementById, 'call', _10 => _10(inputId), 'optionalAccess', _11 => _11.focus, 'call', _12 => _12()])
  }, [custom, inputId])

  const onValueChange = _react.useCallback.call(void 0, (event) => {
    setValue(event.target.value)
    setSkipped(false)
  }, [])
  const onZoneChange = _react.useCallback.call(void 0, (zone) => {
    setSkipped(false)
    onTimeZoneChange(zone)
  }, [onTimeZoneChange])

  const onSubmit = _react.useCallback.call(void 0, (event) => {
    event.preventDefault()
    const wall = _timeZones.fromWallValue.call(void 0, value)
    const sendAt = wall && _timeZones.zonedInstant.call(void 0, wall, timeZone)
    if (wall && !sendAt) {
      setSkipped(true)
      return
    }
    onPick(sendAt || new Date(NaN))
  }, [onPick, value, timeZone])

  return (
    _react2.default.createElement('div', {
      ref: panel,
      role: "dialog",
      // Part of the composer: using it doesn't count as leaving the composer.
      'data-composer-part': true,
      'aria-labelledby': titleId,
      className: "send-later",
      onKeyDown: onKeyDown, __self: this, __source: {fileName: _jsxFileName, lineNumber: 118}}

      , _react2.default.createElement('div', { id: titleId, className: "send-later--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 127}}, title)
      , presets.map(preset => _react2.default.createElement(PresetRow, { key: preset.id, preset: preset, disabled: busy, onPick: onPick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 128}} ))
      , custom ? (
        _react2.default.createElement('form', { className: "send-later--custom", onSubmit: onSubmit, __self: this, __source: {fileName: _jsxFileName, lineNumber: 130}}
          , _react2.default.createElement('label', { htmlFor: inputId, className: "send-later--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 131}}, "Date and time"  )
          , _react2.default.createElement('input', {
            id: inputId,
            type: "datetime-local",
            className: "blm-text-input send-later--input" ,
            min: _timeZones.toWallValue.call(void 0, ceilToMinute(_scheduledMessages.earliestSendAt.call(void 0, now)), timeZone),
            max: _timeZones.toWallValue.call(void 0, _scheduledMessages.latestSendAt.call(void 0, now), timeZone),
            value: value,
            onChange: onValueChange,
            required: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 132}}
          )
          , _react2.default.createElement('button', { type: "submit", className: "send-later--submit", disabled: busy || !value, __self: this, __source: {fileName: _jsxFileName, lineNumber: 142}}, submitLabel)
        )
      ) : (
        _react2.default.createElement('button', { type: "button", className: "send-later--preset send-later--pick" , onClick: showCustom, __self: this, __source: {fileName: _jsxFileName, lineNumber: 145}}, "Pick date & time…"

        )
      )
      , _react2.default.createElement('div', { className: "send-later--zone", __self: this, __source: {fileName: _jsxFileName, lineNumber: 149}}
        , _react2.default.createElement(_ScheduleTimeZone2.default, { timeZone: timeZone, onChange: onZoneChange, __self: this, __source: {fileName: _jsxFileName, lineNumber: 150}} )
      )
      , (skipped || error) && _react2.default.createElement('p', { role: "alert", className: "send-later--error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 152}}, skipped ? SKIPPED_TIME : error)
    )
  )
}

exports. default = _react.memo.call(void 0, SendLaterPanel)
